import { render, staticRenderFns } from "./AuthConfirmation.vue?vue&type=template&id=dab74d56"
import script from "./AuthConfirmation.vue?vue&type=script&lang=js"
export * from "./AuthConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports